import { useEffect } from 'react';
import { useLocation } from 'react-router';

// Central route → title map. Keep in sync with Router.tsx paths.
// Order matters: first matching prefix wins for dynamic routes (e.g. /imports/:id).
const TITLE_RULES: { test: (pathname: string) => boolean; title: string }[] = [
  { test: (p) => p === '/', title: 'Home' },
  { test: (p) => p === '/lo-list', title: 'LO List' },
  { test: (p) => p === '/property-lookup', title: 'Property Lookup' },
  { test: (p) => p === '/quote', title: 'Quote' },
  { test: (p) => p.startsWith('/qs/'), title: 'Retrieve Quote' },
  { test: (p) => p.startsWith('/imports/'), title: 'Import Detail' },

  { test: (p) => p === '/mailers/search', title: 'Mailers Search' },
  { test: (p) => p === '/mailers/my-leads', title: 'My Leads' },
  { test: (p) => p === '/mailers/me/settings', title: 'My Settings' },
  { test: (p) => p === '/mailers/team', title: 'Team Leads' },
  { test: (p) => p === '/mailers/imports', title: 'Mailers Imports' },
  { test: (p) => p.startsWith('/mailers/imports/'), title: 'Import Detail' },
  { test: (p) => p === '/mailers/users', title: 'Mailers Users' },
  { test: (p) => p === '/mailers/teams', title: 'Mailers Teams' },

  { test: (p) => p === '/signin', title: 'Sign In' },
  { test: (p) => p === '/signup', title: 'Sign Up' },
];

export function getPageTitle(pathname: string): string {
  const match = TITLE_RULES.find((rule) => rule.test(pathname));
  return match ? match.title : 'Team Cecero';
}

export function useDocumentTitle() {
  const location = useLocation();
  useEffect(() => {
    const pageName = getPageTitle(location.pathname);
    document.title = pageName === 'Team Cecero' ? 'Team Cecero' : `Team Cecero | ${pageName}`;
  }, [location.pathname]);
}
